class AdBlockerChecker {
  constructor(url, options) {
    this.url = url
    this.options = options || { method: "HEAD", mode: "no-cors" }
  }

  async call(onSuccess, onError) {
    const blockedErrorMsgRegexp = /Failed to fetch|Network|blocked by content blocker/i
    try {
      await fetch(this.url, this.options)
      onSuccess()
    } catch (e) {
      if (blockedErrorMsgRegexp.test(e.message)) {
        onError(e) // Request failed likely due to a content blocker
      } else {
        throw e
      }
    }
  }
}

export default AdBlockerChecker
